import { ChevronDown } from '../../../icons';

export const CountrySelectorAddon = ({
  countryCode = 'US'
}: {
  countryCode?: string;
}) => (
  <div className="flex h-full items-center gap-2 rounded-l-lg border border-r-0 border-[var(--color-border-primary)] bg-primary px-3.5 py-2.5 text-sm font-semibold text-primary shadow-xs transition focus-visible:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-brand-500)]">
    <span className="font-semibold text-placeholder">{countryCode}</span>
    <ChevronDown className="size-4 text-fg-quaternary" aria-hidden="true" />
  </div>
);
